import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {MediaDto} from "../media.dto";

export class SearchMediaRes extends SearchResultDto {

  public override readonly items: SearchMediaItem[] = [];

  constructor(init?: Partial<SearchMediaRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchMediaItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchMediaItem extends MediaDto implements SearchItem {

  public override readonly id!: string;
  public readonly pages: number | undefined;
  public readonly letterAddress: boolean | undefined;
  public readonly attachment: boolean | undefined;
  public readonly invoiceId: string | undefined;
  public readonly contactId: string | undefined;
  public readonly addressId: string | undefined;
  public readonly vehicleId: string | undefined;
  public readonly deathId: string | undefined;
  public readonly articleId: string | undefined;

  constructor(init?: Partial<SearchMediaItem>) {
    super(init);
    Object.assign(this, init);
  }

  isEditable(): boolean {
    return false;
  }
}
